import { z } from "zod";
const calendarDate = z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/)
    .refine((value) => {
    const parsed = new Date(`${value}T12:00:00Z`);
    return (value.slice(0, 4) !== "0000" &&
        !Number.isNaN(parsed.getTime()) &&
        parsed.toISOString().slice(0, 10) === value);
}, "Indica una fecha válida.");
const localTime = z.string().regex(/^([01]\d|2[0-3]):[0-5]\d$/);
export const agendaEventFieldsSchema = z
    .object({
    title: z.string().trim().min(1).max(160),
    date: calendarDate,
    startTime: localTime.nullable(),
    endTime: localTime.nullable(),
    service: z.enum(["balloon", "tour", "school"]).nullable(),
    category: z.enum(["meeting", "call", "task", "other"]),
    status: z.enum(["scheduled", "completed", "cancelled"]),
    location: z.string().trim().max(300),
    notes: z.string().trim().max(4000),
})
    .strict();
export const agendaEventWriteSchema = agendaEventFieldsSchema
    .extend({
    commandId: z.string().uuid(),
    expectedVersion: z.number().int().positive().optional(),
})
    .refine((value) => !value.endTime ||
    Boolean(value.startTime && value.endTime > value.startTime), {
    message: "La hora de fin debe ser posterior a la hora de inicio del mismo día.",
    path: ["endTime"],
});
export const agendaEventQuerySchema = z
    .object({
    from: calendarDate,
    to: calendarDate,
    service: z.enum(["balloon", "tour", "school"]).optional(),
})
    .refine((value) => value.from <= value.to &&
    Date.parse(value.to) - Date.parse(value.from) <= 366 * 86400000, "Consulta un intervalo de hasta un año.");
